import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await axios.post('/auth/login', { login, password });
      const { access_token } = response.data;
      localStorage.setItem('token', access_token);
      navigate('/chat');
    } catch (err) {
      setError('Неверный логин или пароль');
    }
  };

  return (
    <div className='flex items-center justify-center h-screen bg-gray-100'>
      <div className='bg-white p-6 rounded shadow-md'>
        <h2 className='text-2xl mb-4'>Авторизация</h2>
        {error && <p className='text-red-500 mb-4'>{error}</p>}
        <input
          type='text'
          value={login}
          onChange={e => setLogin(e.target.value)}
          placeholder='Логин'
          className='w-full p-2 mb-4 border rounded'
        />
        <input
          type='password'
          value={password}
          onChange={e => setPassword(e.target.value)}
          placeholder='Пароль'
          className='w-full p-2 mb-4 border rounded'
        />
        <button onClick={handleSubmit} className='w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600'>
          Войти
        </button>
      </div>
    </div>
  );
};

export default Login;
